import loadView from "@/utils/load-view";
const routes = [
    {
        path: "/surveys",
        redirect: "/surveys/open",
        meta: {
            authRequired: true,
        },
    },
    {
        path: "/surveys/_id/:id",
        redirect: to => `/surveys/edit/${to.params.id}`,
    },
    {
        path: "/surveys/:tab",
        name: "Surveys",
        component: loadView("Surveys"),
        props: true,
        meta: {
            authRequired: true,
            resolvers: [
                // List resolvers
                () => ({ type: "surveys/surveys/getList" }),
                () => ({ type: "tags/tags/getList", payload: { type: ["surveys"] } }), // get survey tags
                () => ({
                    type: "notifications/profilePreview/getNotifications",
                    payload: { userId: "all", type: "surveyTodo" },
                }),
            ],
        },
    },
    {
        path: "/surveys/edit/:id",
        redirect: to => `/surveys/edit/${to.params.id}/basics`,
    },
    {
        path: "/surveys/edit/:id/:section/:tab?/:category?",
        name: "SurveyEdit",
        component: loadView("SurveysEdit"),
        props: true,
        meta: {
            modal: true,
            authRequired: true,
            resolvers: [
                () => ({ type: "tags/tags/getList", payload: { type: ["surveys"], cache: true } }), // get survey tags
                () => ({ type: "users/location/getList" }), // used in participants locationParticipants.
                () => ({ type: "surveys/surveys/getCategory", payload: { cache: true } }), // get survey category list
                () => ({ type: "surveys/surveys/getQuestionBank", payload: { cache: true } }), // get survey questions
                ({ params: { id } }) => {
                    if (id != "new") {
                        return {
                            type: "surveys/surveys/getDetail",
                            payload: { _id: id, cache: true },
                        };
                    }
                },
            ],
        },
    },
    {
        path: "/surveys/insights/:id",
        redirect: to => `/surveys/insights/${to.params.id}/list`,
    },
    {
        // redirection of old reply link( when a user replies to a conversation)
        path: "/surveys/details/:surveyId/signal/:signal",
        redirect: to => `/surveys/insights/${to.params.surveyId}/comments/${to.params.signal}`,
    },
    {
        path: "/surveys/insights/:id/:tab/:category?",
        name: "SurveyInsights",
        component: loadView("SurveysInsights"),
        meta: {
            modal: true,
            authRequired: true,
            resolvers: [
                ({ params: { id } }) => ({
                    type: "surveys/surveys/getDetail",
                    payload: { _id: id, cache: true },
                }),
                () => ({
                    type: "teams/customrole/getList",
                }),
                () => ({
                    type: "users/customAttribute/getList",
                    payload: { cache: true },
                }),
                () => ({
                    type: "users/location/getList",
                }),
                () => ({
                    type: "teams/local/getList",
                    payload: { filter: "all", cache: true },
                }),
                ({ params: { tab, id, category: commentId } }) => {
                    if (tab === "comments" && commentId && commentId != "") {
                        return {
                            type: "surveys/comments/getDetail",
                            payload: {
                                surveyId: id,
                                commentId,
                            },
                        };
                    }
                },
            ],
        },
    },
    {
        // redirection of answer page.
        path: "/surveys/participate/:surveyId/:notificationId",
        redirect: to => `/surveys/${to.params.surveyId}/answer/${to.params.notificationId}`,
    },
    {
        path: "/surveys/:surveyId/answer/:notificationId",
        name: "SurveyAnswer",
        component: loadView("SurveysAnswer"),
        meta: {
            layout: "LayoutBlank",
            authRequired: false,
            resolvers: [],
        },
    },
];
export default routes;
